// Needs to be before other imports, to enable polyfills
/* import-sort-ignore */
import "@babel/polyfill";

import "../stylesheets/fonts.css";

import { isLocalStorageSupported } from "@outschool/local-storage";
import { BASE_LOCALE } from "@outschool/localization";
import * as Sentry from "@outschool/sentry/dist/client";
import { init as initUiComponentsWebsite } from "@outschool/ui-components-website";
import { createBrowserHistory } from "history";
import React from "react";
import { render } from "react-dom";

import {
  LOCALE,
  OUTSCHOOL_ENV,
  SHOULD_DISABLE_ONGOING_ENROLLMENTS_WITH_CLASSWALLET
} from "../shared/Env";
import * as Routes from "../shared/Routes";
import App from "./components/App";
import { initAnalyticsPackage } from "./lib/analytics";
import { createHistory } from "./lib/history";
import { initI18n } from "./lib/i18n";
import AppState from "./stores/AppState";

initAnalyticsPackage();

// Add any client-side locale overrides here if needed
const userSelectedLocale = LOCALE;

Routes.initRoutes(Sentry.logException, userSelectedLocale);

const i18n = initI18n(userSelectedLocale);

initUiComponentsWebsite({
  env: OUTSCHOOL_ENV,
  SHOULD_DISABLE_ONGOING_ENROLLMENTS_WITH_CLASSWALLET
});

const historyConfig =
  userSelectedLocale === BASE_LOCALE
    ? undefined
    : {
        basename: userSelectedLocale
      };
const history = createHistory(createBrowserHistory(historyConfig));

const appState = new AppState(history, isLocalStorageSupported());

render(
  <App
    appState={appState}
    history={history}
    userSelectedLocale={userSelectedLocale}
    i18n={i18n}
  />,
  document.getElementById("app-main")
);

(window as any).osClientJsLoadedAt = window.performance?.now?.() ?? Date.now();

const difference =
  (window as any).osClientJsLoadedAt - (window as any).osJsStartedAt;
const seconds = (difference / 1000).toFixed(2);
console.log(`OS Client JS finished execution after ${seconds} seconds.`);
